// Style included dressings
const styleIncludedDressings = [
  {
    style_id: 2, // Special
    dressing_id: 8 // Russian Dressing
  },
  {
    style_id: 3, // Super
    dressing_id: 6 // Mayo
  }
];

export default styleIncludedDressings;